import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  data: [{
    tertiaryCtaProps: {
      title: 'Copy'
    },
    value: '12345AB45',
    key: 'Transaction ID'
  }, {
    logoProps: {
      imageUrl: 'https://assets.airtel.in/static-assets/pay-section/xxhdpi/airtel.png',
      variant: 'image',
      onErrorImageUrl: 'https://assets.airtel.in/static-assets/pay-section/xxhdpi/airtel.png'
    },
    value: 'Airtel UPI ₹600',
    key: 'Payment method'
  }, {
    logoProps: {
      imageUrl: 'https://assets.airtel.in/static-assets/pay-section/xxhdpi/airtel.png',
      variant: 'image',
      onErrorImageUrl: 'https://assets.airtel.in/static-assets/pay-section/xxhdpi/airtel.png'
    },
    value: 'HDFC bank',
    key: 'Paid from'
  }, {
    value: 'XXXX2678',
    key: 'Account number'
  }, {
    tertiaryCtaProps: {
      title: 'Copy'
    },
    value: '12345AB45',
    key: 'Transaction ID'
  }, {
    logoProps: {
      imageUrl: 'https://assets.airtel.in/static-assets/pay-section/xxhdpi/airtel.png',
      variant: 'image',
      onErrorImageUrl: 'https://assets.airtel.in/static-assets/pay-section/xxhdpi/airtel.png'
    },
    value: 'Airtel UPI ₹600',
    key: 'Payment method'
  }, {
    logoProps: {
      imageUrl: 'https://assets.airtel.in/static-assets/pay-section/xxhdpi/airtel.png',
      variant: 'image',
      onErrorImageUrl: 'https://assets.airtel.in/static-assets/pay-section/xxhdpi/airtel.png'
    },
    value: 'HDFC bank',
    key: 'Paid from'
  }, {
    value: 'XXXX2678',
    key: 'Account number'
  }],
  column: 1
}, getTestId('KeyPairUnitWidgetContainer'));